class RgMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.triggers = Array.from(this.querySelectorAll('.rg-mega-menu__trigger'));
    this.panels = Array.from(this.querySelectorAll('.rg-mega-menu__panel'));
    this.firstTrigger = this.triggers[0];

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => this.activate(trigger));
      trigger.addEventListener('focus', () => this.activate(trigger));
      trigger.addEventListener('click', () => this.activate(trigger));
    });

    const details = this.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (!details.hasAttribute('open') && this.firstTrigger) this.activate(this.firstTrigger);
      });
    }
  }

  activate(activeTrigger) {
    this.triggers.forEach((trigger) => {
      const isActive = trigger === activeTrigger;
      trigger.classList.toggle('rg-mega-menu__trigger--active', isActive);
      trigger.setAttribute('aria-expanded', isActive);
    });

    const targetId = activeTrigger.getAttribute('data-rg-mega-target');
    this.panels.forEach((panel) => {
      const on = panel.id === targetId;
      panel.classList.toggle('rg-mega-menu__panel--active', on);
      if (on && !panel.classList.contains('is-anim')) {
        // Linkit liukuvat sisään porrastetusti (rg-motion.css); indeksi CSS-muuttujaan
        panel.querySelectorAll('.rg-mega-menu__link').forEach((a, i) => a.style.setProperty('--i', i));
        panel.classList.add('is-anim');
      } else if (!on) {
        panel.classList.remove('is-anim');
      }
    });
  }
}

customElements.define('rg-mega-menu', RgMegaMenu);
